import React from "react";
import { Link } from "~/components/Elements";
import "./Volby2023.css";
const urlAllInfo = "https://www.teraz.sk/parlamentne-volby-2023";

const HeaderBanner = (props) => {

  var showCounter = false;
  var end = new Date('09/30/2023 07:00 AM');
  var _second = 1000;
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;
  function showRemaining() {
      var now = new Date();
      var distance = end - now;
      if (distance < 0) {
          clearInterval(timer);
          return;
      }
      var days = Math.floor(distance / _day).toString();
      var hours = Math.floor((distance % _day) / _hour).toString();
      var minutes = Math.floor((distance % _hour) / _minute).toString();
      var seconds = Math.floor((distance % _minute) / _second).toString();
      if (typeof document !== 'undefined') {
        document.querySelector('.days').innerHTML = ("0" + days).slice(-2);
        document.querySelector('.hours').innerHTML = ("0" + hours).slice(-2);
        document.querySelector('.minutes').innerHTML = ("0" + minutes).slice(-2);
        document.querySelector('.seconds').innerHTML = ("0" + seconds).slice(-2);
     }      
  }

  timer = setInterval(showRemaining, 1000);
  showCounter = true;

  return (
    <div>
      <div className="bannerBase referendum-fullWidth">
            <div className="bannerBase-inner referendum-inner elections">
                <div className="bannerCountdownWrapper" style={{ visibility: showCounter ? 'visible' : 'hidden' }}>
                  <div>
                    <div className="label">Dni</div>
                    <div className="days val">&nbsp;</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Hodiny</div>
                    <div className="hours val">&nbsp;&nbsp;</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Minúty</div>
                    <div className="minutes val">&nbsp;&nbsp;</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Sekundy</div>
                    <div className="seconds val">&nbsp;&nbsp;</div>
                  </div>                  
                </div>

                <div className="bannerBase-elections-title-wrapper">
                  <span>Parlamentné voľby 2023</span>
                </div>

                <Link to={urlAllInfo}>
                  <div className="bannerBase-referendum-btn no-margin">Všetko o voľbách</div>
                </Link>

                <Link className="fullAreaBtn" to={urlAllInfo}><div className="bannerBase-referendum-fullBtnArea"></div></Link>                
            </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
